import React from "react";
import ReactDOMServer from "react-dom/server";
import { ReactComponent as BoldIcon } from "../../assets/svg/editor/bold-icon.svg";
import { ReactComponent as ItalicIcon } from "../../assets/svg/editor/italic-icon.svg";
import { ReactComponent as UnderlineIcon } from "../../assets/svg/editor/underline-icon.svg";
import { ReactComponent as StrikethroughIcon } from "../../assets/svg/editor/align-1.svg";
import { ReactComponent as BulletedListIcon } from "../../assets/svg/editor/align-2.svg";
import { ReactComponent as NumberedListIcon } from "../../assets/svg/editor/align-3.svg";
import { ReactComponent as LinkIcon } from "../../assets/svg/editor/link.svg";
import { ReactComponent as ImageIcon } from "../../assets/svg/editor/image-icon.svg";

const toSvgString = (element: React.ReactElement) =>
  ReactDOMServer.renderToStaticMarkup(element);

export const articleEditorIcons = {
  bold: toSvgString(React.createElement(BoldIcon)),
  italic: toSvgString(React.createElement(ItalicIcon)),
  underline: toSvgString(React.createElement(UnderlineIcon)),
  strike: toSvgString(React.createElement(StrikethroughIcon)),
  list: {
    ordered: toSvgString(React.createElement(NumberedListIcon)),
    bullet: toSvgString(React.createElement(BulletedListIcon)),
  },
  link: toSvgString(React.createElement(LinkIcon)),
  image: toSvgString(React.createElement(ImageIcon)),
};

export default articleEditorIcons;
